import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createCompany } from '../api/company'
import './CompanyRegistration.css'
import { NoticeModal } from '../components/Modals';
import RegistarLayout from '../components/RegistarLayout';
import InputFormLayout from '../components/InputFormLayout';
import RegistarButtonLayout from '../components/RegistarButtonLayout';

const CompanyRegistration = () => {
  const [companyName, setCompanyName] = useState('')
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [noticeMsg, setNoticeMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    try {
      const response = await createCompany(companyName)
      console.log('response:', response)

      const companyId = response.company?.id
      if (!companyId) {
        setError('会社IDが返ってきませんでした。管理者にお問い合わせください。')
        return
      }

      setNoticeMsg('企業登録が完了しました');
      setNoticeOpen(true);
      
      navigate('/implpage')

    } catch (err) {
      console.error(err)

      if (err.response && err.response.status === 422 && err.response.data.errors) {
        const validationErrors = err.response.data.errors
        const messages = Object.values(validationErrors).flat().join('\n')
        setError(messages)
      } else {
        setError('登録に失敗しました。時間をおいて再度お試しください。')
      }
    }
  }

  return (
    <RegistarLayout title="企業登録" margin="0 auto" marginTop="15vh">
        <InputFormLayout
          id="companyName"
          labelTitle="企業名"
          type="text"
          value={companyName}
          onChange={e => setCompanyName(e.target.value)}
          placeholder="企業名を入力してください"
        />
      <div className='registButtons'>
        {error && <p style={{ color: 'red', whiteSpace: 'pre-wrap' }}>{error}</p>}
        <RegistarButtonLayout
          buttonTitle="登録"
          type="submit"
          onClick={handleSubmit}
        />
        <RegistarButtonLayout
          buttonTitle="企業ポータルに戻る"
          type="button"
          onClick={() => navigate('/implpage')}
        />
      </div>
      <NoticeModal
        open={noticeOpen}
        onClose={() => setNoticeOpen(false)}
        message={noticeMsg}
      />
    </RegistarLayout>
  )
}

export default CompanyRegistration